// extracted by mini-css-extract-plugin
module.exports = {"stickerIcon":"styles_stickerIcon__2sGEq"};